import { DynamicConfig, IDynamicConfig, IDynamicFormConfig } from '@mt-ng2/dynamic-form';
import { IDonorUser } from '@model/interfaces/donor-user';
import { DonorUserDynamicControls } from '@model/form-controls/donor-user.form-controls';

export class DonorRegistrationDynamicConfig<T extends IDonorUser> extends DynamicConfig<T> implements IDynamicConfig<T> {
    constructor(private user: IDonorUser, private configControls?: string[]) {
        super();
        const dynamicControls = new DonorUserDynamicControls(this.user);
        // default form implementation can be overridden at the component level
        if (!configControls) {
            this.configControls = ['FirstName', 'MiddleInitial', 'LastName', 'Email'];
        }
        this.setControls(this.configControls, dynamicControls);
    }

    getForUpdate(additionalConfigs?: any[]): IDynamicFormConfig {
        return {
            formObject: this.getFormObject(additionalConfigs),
            viewOnly: this.DynamicLabels,
        };
    }

    getForCreate(additionalConfigs?: any[]): IDynamicFormConfig {
        return {
            formObject: this.getFormObject(additionalConfigs),
        };
    }
}
